export default "__VITE_ASSET__69d9c86b__"